import { Box, Button, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import dayjs from 'dayjs'

export const START_PEER_TO_PEER_URL = 'https://www.gvsu.edu/autismcenter/start/peer-to-peer-9'

const styles = {
  card: {
    width: { xs: '100%', sm: '450px' },
    mt: '40px',
    p: '24px',
    borderRadius: '16px',
    backgroundColor: 'var(--purple-500)',
    boxShadow: 'var(--shadow-md)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    textAlign: 'center'
  },
  icon: {
    fontSize: '80px',
    color: 'var(--green-500)'
  },
  cardText: {
    color: 'var(--white)',
    fontSize: '16px'
  },
  webpageButton: {
    width: '100%',
    p: '12px 24px',
    borderRadius: '4px',
    backgroundColor: 'var(--white)',
    color: 'var(--grey-700)',
    fontSize: '16px',
    lineHeight: 1.7,
    boxShadow: 'none',
    '&:hover': { backgroundColor: 'var(--grey-100)', boxShadow: 'none' }
  }
}

interface Props {
  editableUntil?: string | null
}

export const SubmissionSummary = ({ editableUntil }: Props): JSX.Element => {
  const untilDate = editableUntil != null && editableUntil !== '' ? dayjs(editableUntil.slice(0, 10)).format('MM/DD/YYYY') : null

  return (
    <Box data-testid='p2pSubmissionSummary'>
      <Typography variant='h3'>Thank you!</Typography>
      <Typography variant='body1' sx={{ maxWidth: '340px' }} data-testid='p2pSubmissionEditWindow'>
        You&apos;re all set! If you need to make changes, you can log back in and update your submission
        {untilDate != null ? ` until ${untilDate}.` : ' until the reporting year closes.'}
      </Typography>

      <Box sx={styles.card}>
        <CheckCircleIcon sx={styles.icon} />
        <Box>
          <Typography variant='h4' sx={{ color: 'var(--white)' }}>Report Submitted!</Typography>
          <Typography variant='body1' sx={styles.cardText}>Your data has been successfully submitted.</Typography>
        </Box>
        <Typography variant='body1' sx={styles.cardText}>
          Visit the Peer to Peer Webpage for resources, tools, and the latest information.
        </Typography>
        <Button
          variant='contained'
          href={START_PEER_TO_PEER_URL}
          target='_blank'
          rel='noopener noreferrer'
          sx={styles.webpageButton}
          data-testid='p2pVisitPeerToPeerWebpage'
        >
          Visit the START Peer to Peer Webpage
        </Button>
      </Box>
    </Box>
  )
}
